import { flatten, fromPairs, random, times } from 'lodash'
import { supportedPlateFormats } from '~/components/TinyMicroplate.interface'
import { DemoConfig } from '~/pages/slasDemo/CommandCenter/SlasDemoConfigDialog/DemoConfig'
import { getWellMatrix } from '~/utils/microplate'
import { PlateCheckedIn } from '../../DemoEvent'
import { makeUniqueID } from '../makeUniqueID'
import { NUM_DATASETS } from './generateDataset'
import { generateExperimentLabelsForCellLine } from './generateExperimentLabelsForCellLine'
import { generatePlateName } from './generatePlateName'

// Sample of real cell lines
// ACS-1021 - ATCC iPS cell line
// ACS-1024 - ATCC iPS cell line
// KOLF2.1J - Jackson Lab iPS cell line
// KOLF2.1S - Sanger Institute iPS cell line
const CELL_LINES = ['ACS-1021', 'ACS-1024', 'KOLF2.1J', 'KOLF2.1S']

export function generatePlateCheckedInEvents(
  plateCount: number,
  day: number,
  at: string,
  numExistingPlates: number,
  // DemoConfig.profile is used when generating the plate name.
  config: DemoConfig,
): PlateCheckedIn[] {
  return times(plateCount, j =>
    makePlateCheckedInEvent({
      at,
      day,
      plateName: generatePlateName(numExistingPlates + j + 1, config),
      cellLine: CELL_LINES[0],
      experimentLabel: generateExperimentLabelsForCellLine(CELL_LINES[0], config)[0],
      plateFormat: 'wells_6',
    }),
  )
}

export function makePlateCheckedInEvent({
  at,
  day,
  plateName,
  cellLine,
  experimentLabel,
  plateFormat,
}: {
  at: string
  day: number
  plateName: string
  cellLine: string
  experimentLabel: string
  plateFormat: supportedPlateFormats
}): PlateCheckedIn {
  const plateWells = flatten(getWellMatrix(plateFormat))

  return {
    kind: 'PlateCheckedIn',
    at,
    day,

    plateFormat,
    plateID: makeUniqueID('PLATE'),
    plateName,

    experimentLabel,
    cellLine,

    wellNameToCulture: fromPairs(
      plateWells.map(well => [
        well,
        { id: makeUniqueID('CULTURE'), datasetIndex: random(NUM_DATASETS - 1) },
      ]),
    ),
  }
}
